/**
 * @generated SignedSource<<e72766e2350a1ccb4d06670262c85f1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceFilesFile_file$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  };
  readonly formattedSize: string;
  readonly id: string;
  readonly name: string | null;
  readonly type: FileType | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"FileIconBox_file">;
  readonly " $fragmentType": "WorkspaceFilesFile_file";
};
export type WorkspaceFilesFile_file$key = {
  readonly " $data"?: WorkspaceFilesFile_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceFilesFile_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceFilesFile_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIconBox_file"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "4ec77a9a69a509692a653d20e92c8a2f";

export default node;
